import React from 'react';

interface CopyIconProps {
  color: string;
}

const CopyIcon: React.FC<CopyIconProps> = ({ color }): JSX.Element => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12_444)">
        <path
          d="M9.28571 0H14.8259C15.3929 0 15.9375 0.219141 16.3393 0.605859L19.3705 3.52344C19.7723 3.91016 20 4.43438 20 4.98008V14.4375C20 15.5762 19.0402 16.5 17.8571 16.5H9.28571C8.10268 16.5 7.14286 15.5762 7.14286 14.4375V2.0625C7.14286 0.923828 8.10268 0 9.28571 0ZM2.14286 5.5H5.71429V8.25H2.85714V19.25H11.4286V17.875H14.2857V19.9375C14.2857 21.0762 13.3259 22 12.1429 22H2.14286C0.959821 22 0 21.0762 0 19.9375V7.5625C0 6.42383 0.959821 5.5 2.14286 5.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_12_444">
          <rect width="20" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CopyIcon;
